import {
  Customer,
  Invoice,
  Sale,
  DianInvoice,
  DianSale,
  DocumentType,
  Seller,
} from '@shared-models';

import { ArticleMapper } from './article.mapper';
import { ContributorTypeMapper } from './contributor-type.mapper';
import { CountryMapper } from './country.mapper';
import { OrganizationTypeMapper } from './organization-type.mapper';

export class InvoiceMapper {
  static mapper(invoice: Invoice, currency?: string): DianInvoice {
    return {
      id_factura: invoice.id_factura.toString(),
      tax: invoice.tax.toString(),
      dueDate: invoice.dueDate,
      createdAt: invoice.invoiced_date ?? invoice.createdAt,
      venta: this.mapSales(invoice.venta),
      cliente: this.mapCustomer(invoice.cliente),
      seller: this.mapSeller(invoice.seller),
      tax_incl: invoice.tax_incl,
      billyInvoice: {
        invoice_number: invoice.billyInvoice.invoice_number,
        cufe: invoice.billyInvoice.cufe ?? '',
      },
      observations: invoice.observations,
      currency: currency ? currency : invoice.currency,
    };
  }

  private static mapSales(sales?: Sale[] | null): DianSale[] {
    return (
      sales?.map(
        (sale): DianSale => ({
          cantidad: sale.cantidad.toFixed(2),
          precio: sale.precio.toFixed(2),
          descuento: sale.descuento.toFixed(2),
          subtotal: sale.subtotal.toFixed(2),
          total: sale.total.toFixed(2),
          // cantidad is expressed in the line's sale unit, so the unit reported
          // to DIAN has to match it.
          articulo: ArticleMapper.mapper(sale.articulo[0], sale.id_sale_unit),
        }),
      ) ?? []
    );
  }

  private static mapCustomer(customer: Customer) {
    return {
      types_docs: this.mapDocumentType(customer.types_docs[0]),
      doc_nit: customer.doc_nit,
      nombre: customer.nombre,
      direccion: customer.direccion,
      telefono: customer.telefono,
      email: customer.email,
      country: CountryMapper.mapper(customer.country),
      city: customer.city,
      contributorType: ContributorTypeMapper.mapper(customer.contributorType),
      customer_type: OrganizationTypeMapper.mapper(customer.customer_type),
      verification_digit: customer.verification_digit.toString(),
    };
  }

  private static mapDocumentType(documentType: DocumentType) {
    return {
      description: documentType.description,
      dian_code: documentType.dian_code,
    };
  }

  private static mapSeller(seller: Seller) {
    return {
      id_seller: seller.id_seller.toString(),
      doc_nit: seller.doc_nit,
      nombre: seller.nombre,
    };
  }
}
